import lobbySdk from '@corefront/eva-fe-sdk';
import { EVA_API_SERVICE_NAME } from '../constants/api';

let api: ReturnType<typeof lobbySdk>;

interface Options {
  baseUrl: string;
}

export const initAPI = ({ baseUrl }: Options) => {
  api = lobbySdk({
    productType: EVA_API_SERVICE_NAME,
    baseUrl,
  });
};

export const getAPI = () => api;
